module.exports = __webpack_public_path__ + "img/footer.138325cc.png";